import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CallHandlingBox, CallBtn } from './style';
import { connect } from 'react-redux';
import { FaHeadset, FaUserFriends, FaUser, FaAssistiveListeningSystems } from 'react-icons/fa';
import { RiUser6Line } from 'react-icons/fa';
import CallInfo from '../../CallInfo';
import { globalStateSelector } from 'store/selector';
import { callAction, globalAction, messageAction } from 'store/action';
import { CallHandlerTheme, BardgeButton, PreviewButton } from 'modules/theme';
global.__btnTimer = "";
export class CallHandler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHold: false,
      isMute: false,
      isConference: false,
      isMonitor: (props.monitorState == "Monitor") ? true : false,
      dtmf: false,
      tag: false,
      monitorState: 'listen'
    };
    this.callHangup = this.callHangup.bind(this);
    this.callHoldToggle = this.callHoldToggle.bind(this);
    this.callMuteToggle = this.callMuteToggle.bind(this);
    this.dtmfToggle = this.dtmfToggle.bind(this);
    this.acwToggle = this.acwToggle.bind(this);
    this.infoToggle = this.infoToggle.bind(this);
    this.addTransferCall = this.addTransferCall.bind(this);
    this.startTimer = this.startTimer.bind(this);
  }
  componentWillReceiveProps(nextProps) {

    if( typeof nextProps.monitorState != "undefined" ){
      let isMonitor = false;
      if( nextProps.monitorState && nextProps.monitorState == "Monitor") {
        isMonitor = true;
      }
      if( this.state.isMonitor !== isMonitor ){
        this.setState({"isMonitor" : isMonitor });
      }
    }
  }
  startTimer( state, previousState  ){
    const { callInfo, dynamicUpdate } = this.props;
    dynamicUpdate({ key: 'callHandlingState', value: state});
    clearTimeout(global.__btnTimer)
    global.__btnTimer = setTimeout(() => {
      dynamicUpdate({ key: 'callHandlingState', value: previousState });
    }, 10000);;
  }
  callHangup() {
    let { callInfo, userState, callState, callTeam, teamList } = this.props;
    let state = userState && userState.State ?  userState.State : '';
    if( callState == "muteLoading" ){
      if( state == "MUTE"  ){
        callState = "mute"
      } else {
        callState = ""
      }
    }
    else if( callState == "holdLoading" ){
      if( state == "HOLD" ){
        callState = "hold"
      } else {
        callState = ""
      }
    }
    else if( callState == "transferLoading" ){
      if( state == "TRANSFER_START" ){
        callState = "transfer"
      } else {
        callState = ""
      }
    }
    this.startTimer( "endLoading", callState  )

    let csat = false;
    let flowName = "";
    let teamId  = callTeam && callTeam.id ? callTeam.id : "";
    try {
      let teams = teamList.filter((el)=>{ return el._id == teamId})
      if( teams && teams[0] && teams[0].csat && teams[0].csatFlowId ){
        if( teams[0].csat == true ||  teams[0].csat == "TRUE" ){
          csat = true;
          flowName = teams[0].csatFlowId;
        }
      }
    } catch (error) {
    }

    this.sendMessage('callHangup', {
      sessionId: callInfo.sessionId,
      callId: callInfo.agentId,
      isCSAT : csat,
      tFlowName : flowName
    });
  }
  callHoldToggle() {
    const { callInfo, dynamicUpdate, callState } = this.props;
    if (this.state.isHold) {
      this.sendMessage('callUnHold', {
        sessionId: callInfo.sessionId,
        callId: callInfo.agentId
      });
    } else {
      this.sendMessage('callHold', {
        sessionId: callInfo.sessionId,
        callId: callInfo.agentId
      });
    }
    this.setState({ isHold: !this.state.isHold });
    this.startTimer( "holdLoading", callState  )
  }
  callMuteToggle() {
    const { callInfo, dynamicUpdate, callState } = this.props;
    if (this.state.isMute) {
      this.sendMessage('callUnMute', {
        sessionId: callInfo.sessionId,
        callId: callInfo.agentId
      });
    } else {
      this.sendMessage('callMute', {
        sessionId: callInfo.sessionId,
        callId: callInfo.agentId
      });
    }
    this.setState({ isMute: !this.state.isMute });
    this.startTimer( "muteLoading", callState  );
  }
  onDtmfClick( digit ) {
    const { callInfo } = this.props;
    this.sendMessage('dtmfSend', {
      sessionId: callInfo.sessionId,
      callId: callInfo.agentId,
      receive: true,
      dtmf: digit
    });
  }
  dtmfToggle() {
    const { dynamicUpdate } = this.props;
    dynamicUpdate({ key: 'callTab', value: "DTMF" });
  }
  acwToggle() {
    const { dynamicUpdate } = this.props;
    dynamicUpdate({ key: 'callTab', value: "ACW" });
  }
  infoToggle() {
    const { dynamicUpdate } = this.props;
    dynamicUpdate({ key: 'callTab', value: "INFO" });
  }
  addTransferCall() {
    const { dynamicUpdate, callInfo, configProcessor, callTeam, team, callState } = this.props;
    let teamId  = callTeam && callTeam.id ? callTeam.id : team._id;
    this.sendMessage('callTransferStart', {
      sessionId: callInfo.sessionId,
      callId: callInfo.agentId,
      callId2: callInfo.custId,
    });
    dynamicUpdate({ key: 'transferSelectedTeam', value: {}});
    dynamicUpdate({ key: 'transferList', value: []});
    dynamicUpdate({ key: 'transferTab', value: "agent"});
    configProcessor(`liveMonitor`,{
      "teamId" : teamId,
      "transfer" : "AGENT"
    });
    this.startTimer( "transferLoading", callState  )
  }
  sendMessage(type, message) {
    const { callProcess } = this.props;
    callProcess(type, message);
  }
  callStateForReconnect( callState, state ) {

    if( state == "MUTE" && callState != "muteLoading" ){
      callState = "mute"
    }
    else if( state == "HOLD" && callState != "holdLoading" ){
      callState = "hold"
    }
    return callState;
  }
  render() {
    let { ringing, userState, callState } = this.props;
    let state = userState && userState.State ?  userState.State : '';
    let  _this = this;
    callState = this.callStateForReconnect( callState, state );
    return (
      <div style={{height: "100%"}}>
        {
          state == "preview" &&
          <CallInfo isPreview={true}/>
        }
        {
          state == "callback" &&
          <CallInfo isCallback={true}/>
        }
        { state != "preview" && state != "callback" && !this.state.isMonitor &&
          <CallHandlerTheme
            ringing={ringing}
            callState={callState}
            onClickFuncMute={this.callMuteToggle}
            labelNameMute={'Mute'}
            iconMute={<img src={ `/images/dialpad/` + ( callState == "mute" ? "unmute.svg" : "mute.svg")}/>}

            onClickFuncHold={this.callHoldToggle}
            labelNameHold={'Hold'}
            iconHold={<img src={ `/images/dialpad/` + ( callState == "hold"  ? "unhold.svg" : "hold.svg")}/>}

            onClickFuncKeypad={this.dtmfToggle}
            labelNameKeypad={'Keypad'}
            iconKeypad={<img src={"/images/dialpad/dtmf.svg"} />}

            onClickFuncTag={this.acwToggle}
            labelNameTag={'Tag'}
            iconTag={<img src={"/images/dialpad/tag.svg"} />}

            onClickFuncAddCall={this.addTransferCall}
            labelNameAddCall={'Add Call'}
            iconAddCall={<img src={"/images/dialpad/addCall.svg"} />}

            onClickFuncInfo={this.infoToggle}
            labelNameInfo={'Info'}
            iconInfo={<img src={"/images/dialpad/info.svg"} />}

            onClickBtn={this.callHangup}
            btn={'images/call-decline.svg'}
          >
          </CallHandlerTheme>
        }
        { state != "preview" &&
          this.state.isMonitor &&
          <BardgeButton
            // iconCustomer={<img src={ `/images/dialpad/` + ( this.state.monitorState == "customer" ? "unmute.svg" : "mute.svg")}/>}
            // iconAgent={<img src={ `/images/dialpad/` + ( this.state.monitorState == "agent" ? "unmute.svg" : "mute.svg")}/>}
            // iconBoth={<img src={ `/images/dialpad/` + ( this.state.monitorState == "both" ? "unmute.svg" : "mute.svg")}/>}
            // iconListen={<img src={ `/images/dialpad/` + ( this.state.monitorState == "listen" ? "unmute.svg" : "mute.svg")}/>}
            iconCustomer={ <FaHeadset/> }
            iconAgent={ <FaUserFriends/> }
            iconBoth={ <FaUser/> }
            iconListen={ <FaAssistiveListeningSystems/> }
            monitorCustomer={()=>{
              this.setState({monitorState:"customer"})
              this.onDtmfClick(1)
            }}
            monitorAgent={()=>{
              this.setState({monitorState:"agent"})
              this.onDtmfClick(2)
            }}
            monitorBoth={()=>{
              this.setState({monitorState:"both"})
              this.onDtmfClick(3)
            }}
            monitorListen={()=>{
              this.setState({monitorState:"listen"})
              this.onDtmfClick(0)
            }}
            monitorState={this.state.monitorState}
            labelMonitorCustomer={"Customer"}
            labelMonitorAgent={"Agent"}
            labelMonitorBoth={"Both"}
            labelMonitorListen={"Listen"}
            onClickBtn={this.callHangup}
            btn={'images/call-decline.svg'}
          ></BardgeButton>
        }
      </div>
    );
  }
}
CallHandler.contextTypes = {
  __: PropTypes.func
};

CallHandler.propTypes = {
  callInfo: PropTypes.object,
  userState: PropTypes.object,
  callProcess: PropTypes.func
};
const stateToProps = state => ({
  monitorState: globalStateSelector.getMonitorState(state),
  callInfo: globalStateSelector.getInfo(state),
  team: globalStateSelector.getSelectedTeam(state),
  userState: globalStateSelector.getState(state),
  callTeam: globalStateSelector.getDynamic(state, { key: 'callTeam' }),
  ringing: globalStateSelector.getDynamic(state, { key: 'ringing' }),
  callState: globalStateSelector.getDynamic(state, { key: 'callHandlingState' }),
  teamList: globalStateSelector.getTeamList(state),
});

const dispatchToProps = dispatch => ({
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  configProcessor: (type, messageData) => {
    dispatch(messageAction.configProcessor(type, messageData));
  }
  // callTab: globalStateSelector.getDynamic(state, { key: 'callTab' })
});
export default connect(stateToProps, dispatchToProps)(CallHandler);



// WEBPACK FOOTER //
// src/dialpad/components/layout/components/call/CallHandler.js